import { SideNav } from "components";
import {
  MainBody,
  PageTitle,
  OverlayLoader,
  Ptag,
  LargeButton,
} from "components/core";
import { BaseSnackbar } from "components/core";
import http from "services/httpService";
import HeaderDasNew from "components/core/headerDasNew";
import UploadFile from "components/UploadFile";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import routes from "components/routes";
import { FLEX_PRODUCTS } from "constants";
import { FlexProductList } from "pages/CareDashboard/styles";
import { Divider } from "@mui/material";

const UploadEmployeeSheet = () => {
  const flexProductsList = JSON.parse(
    localStorage.getItem("flex_products_list")
  );
  const prodDetails = JSON.parse(localStorage.getItem("gmc_details"));
  const navigate = useNavigate();
  const [errors, setError] = useState(false)
  const [productIds, setProductIds] = useState()
  const [snackBarError, setShackBarError] = useState([])
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [uploadErrorData, setUploadErrorData] = useState([]);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    const updatedProductList = Object.keys(prodDetails).map((val) => ({
      productCode: val,
      userplan_id: prodDetails[val].userplan_id,
    }));
    setProductList(updatedProductList);
    const newProductIds = updatedProductList.reduce((result, { userplan_id }) => {
      result[userplan_id] = null;
      return result;
    }, {});
    setProductIds(newProductIds);
  }, []);  

  const navigateToNextProduct = () => {
    navigate(`/${routes.FLEX_DASHBOARD}`);
  };
console.log(snackBarError)
  const company_name = useMemo(() => {
    return localStorage.getItem("company_name") || "";
  }, [localStorage.getItem("company_name")]);
  
  const handleProductSelect = (selectedId, id) => {
    setProductIds((prevState) => ({
      ...prevState,
      [selectedId]: id,
    }));
  };

  const downloadExcel = async (planId) => {
    const payload = {
      plan_id: planId,
    };
    const { data } = await http.post(
      "business/product_employee_sheet_skeleton/",
      payload,
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_sheet.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };
  const handleSubmit = async () => {
    const enrollment_id_list = localStorage.getItem("enrollmentIdList");
    const areAllValuesNull = Object.values(productIds).every(value => value === null);
    if (areAllValuesNull) {
      setError(true);
      alert('Please upload atlest one employee sheet.')
      return; // Exit the handleSubmit function if all values are null
    }
    try {
      setLoading(true);
      let { data } = await http.post(
        "/business/product_wise_employee_data_upload_ex/",
        {
          // userplan_id: getProductDetail().userplan_id,
          product_employee_sheet_mapping: productIds,
          enrollment_id_list: JSON.parse(enrollment_id_list) || null,
        }
      );

      console.log(data);
      navigateToNextProduct();
    } catch (ex) {
      console.log(ex.response.data);
      console.log(typeof(ex.response.data), "i am here response data")
      if(typeof(ex.response.data)== 'string'){
        alert(ex.response.data)
      }else{
        setShackBarError(Object.entries(ex.response.data))
        setShowSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
    return;
  };
  return (
    <>
      <SideNav />
      <HeaderDasNew company_name={company_name} />
      <MainBody>
        <WidthLimiter>
        <Ptag
          marginBottom="2rem"
          fontSize="24px"
          fontWeight="700"
        >Endorsements</Ptag>
        <Divider/>
          {productList.map((value) => {
            return (
              <React.Fragment key={value}>
                {/* <Ptag
                  marginBottom="2rem"
                  fontSize="20px"
                  fontWeight="600"
                >{`Upload ${FLEX_PRODUCTS[value.productCode]}`}</Ptag> */}
                <UploadFile
                  text="Upload Excel"
                  label={`${FLEX_PRODUCTS[value.productCode]}`}
                  sampleFile="FlexEmployeeSheet"
                  // showError={errors && productIds.userplan_id == null}
                  productType="ghi"
                  onSelect={(id) => handleProductSelect(value.userplan_id, id)}
                  format="excel"
                  type="employees_excel"
                  onDownload={() => downloadExcel(value.userplan_id)}
                />
              </React.Fragment>
            );
          })}
        <div style={{ bottom: "2rem" }}>
          <LargeButton
            type="submit"
            label="Save & Next"
            marginTop="2rem"
            onClick={handleSubmit}
          />
        </div>
        </WidthLimiter>
      </MainBody>
      {
        snackBarError.map((value)=>{
          return (<BaseSnackbar
            open={showSnackbar}
            handleClose={() => setShowSnackbar(false)}
            message={value[1]}
            type="error"
          />)
        })
      }
    </>
  );
};

export default UploadEmployeeSheet;
